import { createSlice } from '@reduxjs/toolkit'

import { STORED_ADMIN_TAB } from '../../constants/tempStorage'

const STAFF_MANAGER_TAB = 0

const getInitialTabIndex = () => {
  try {
    const stored = sessionStorage.getItem(STORED_ADMIN_TAB)
    return stored !== null ? JSON.parse(stored) : STAFF_MANAGER_TAB
  } catch {
    return STAFF_MANAGER_TAB
  }
}

const initialState = {
  tab_index: getInitialTabIndex(),
}

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setTabIndex(state, action) {
      state.tab_index = action.payload
      sessionStorage.setItem(STORED_ADMIN_TAB, JSON.stringify(action.payload))
    },
  },
})

export const { setTabIndex } = adminSlice.actions
export default adminSlice.reducer
